import XLSX from 'xlsx'
import ExcelJS from 'exceljs'

export function gerarArquivoExcel(wsName, data, fileName) {
  const wb = XLSX.utils.book_new()
  const ws_name = wsName

  const ws = XLSX.utils.aoa_to_sheet(data)

  /* Add the worksheet to the workbook */
  XLSX.utils.book_append_sheet(wb, ws, ws_name)

  const write_opts = {
    type: 'base64',
  }
  XLSX.writeFile(wb, fileName, write_opts)
}

export function gerarArquivoExcelMultiSheet(sheets, fileName) {
  const wb = XLSX.utils.book_new()

  sheets.forEach(({ wsName, data }) => {
    const ws = XLSX.utils.aoa_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, wsName)
  })

  const write_opts = {
    type: 'base64',
  }
  XLSX.writeFile(wb, fileName, write_opts)
}

/**
 * Gera um arquivo excel protegido, onde apenas as colunas informadas em
 * `colunasBloqueadas` (índice iniciando em 1) ficam bloqueadas para edição.
 */
export async function gerarArquivoExcelComColunasBloqueadas(
  wsName,
  data,
  fileName,
  colunasBloqueadas = [],
) {
  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet(wsName)

  data.forEach(linha => sheet.addRow(linha))

  const totalColunas = data.reduce((total, linha) => Math.max(total, linha.length), 0)

  for (let coluna = 1; coluna <= totalColunas; coluna++) {
    sheet.getColumn(coluna).protection = { locked: colunasBloqueadas.includes(coluna) }
  }

  await sheet.protect('', {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: true,
    formatColumns: true,
    formatRows: true,
    sort: true,
    autoFilter: true,
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}
